//
//
//
//
//
//
//
//
//

export default {
  name: 'card',

  props: {
    height: {
      type: String,
      default: 'auto'
    },

    horizontal: Boolean,

    img: String
  },

  computed: {
    classes () {
      return {
        'card--horizontal': this.horizontal
      }
    },

    styles () {
      const styles = {
        height: this.height
      }

      if (this.img) {
        styles.background = `url(${this.img}) center center / cover no-repeat`
      }

      return styles
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/Card.vue